import { axiosPrivate } from "./axios";

/**
 * ABS Assistant API (/api/assistant). The AI runs on the backend; the browser
 * never talks to a model. Every function returns `response.data`.
 *
 * chat    -> { success, data: { type: "draft" | "clarification", message, draft, draftToken } }
 *            Nothing is created or stored by this call.
 * confirm -> { success, data: { id, url, task, duplicate } }
 *            Call it only after the user explicitly confirms a draft.
 */
const BASE = "/api/assistant";

export const assistantService = {
  /** { data: { model } }: the model name (AI_MODEL) shown as "powered by". */
  info: async () => (await axiosPrivate.get(`${BASE}/info`)).data,
  chat: async ({ message, history = [], draft = null }) =>
    (await axiosPrivate.post(`${BASE}/tasks/chat`, { message, history, ...(draft ? { draft } : {}) })).data,
  confirm: async ({ draft, draftToken }) =>
    (await axiosPrivate.post(`${BASE}/tasks/confirm`, { draft, draftToken })).data,
};
